import styles from '../../pages/home_page/Hero.module.scss';

export const Rectangle = () => {
    return (
        <svg width="850" viewBox="0 0 878 1185" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.rectangle}>
            <rect x="0.111328" width="877.778" height="1185" rx="438.889" fill="#FFD6E5"/>
        </svg> 
    )
}